import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row q-gutter-sm q-my-sm"
}
const _hoisted_2 = {
  key: 0,
  class: "col"
}
const _hoisted_3 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_header = _resolveComponent("form-header")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_card, {
    style: {"min-width":"280px"},
    class: "q-pa-md"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_form_header, { "header-text": _ctx.header }, null, 8, ["header-text"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData, (item, key) => {
        return (_openBlock(), _createBlock(_component_q_card_section, {
          key: key,
          class: "q-pt-none"
        }, {
          default: _withCtx(() => [
            (_ctx.formData[key])
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (key === 'carts' || key === 'pedestals')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_q_select, {
                          filled: "",
                          modelValue: _ctx.option[key === 'carts' ? 'carts' : 'pedestals'],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.option[key === 'carts' ? 'carts' : 'pedestals']) = $event),
                          "use-input": "",
                          options: _ctx.options[key === 'carts' ? 'carts' : 'pedestals'],
                          color: "accent",
                          label: _ctx.formLabel('type'),
                          behavior: "menu"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_q_input, {
                      filled: "",
                      clearable: "",
                      ref_for: true,
                      ref: (_ctx.getFormRef(_ctx.index) as any),
                      modelValue: _ctx.formData[key].value,
                      "onUpdate:modelValue": ($event: any) => ((_ctx.formData[key].value) = $event),
                      label: _ctx.formItem(key),
                      type: item.type
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "type"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createVNode(_component_q_card_actions, {
        align: "right",
        class: "text-primary"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_q_btn, {
            flat: "",
            label: _ctx.formLabel('close')
          }, null, 8, ["label"]), [
            [_directive_close_popup]
          ]),
          _withDirectives(_createVNode(_component_q_btn, {
            color: "primary",
            label: _ctx.formLabel('save'),
            onClick: _ctx.save
          }, null, 8, ["label", "onClick"]), [
            [_directive_close_popup]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}